import util from '../lib/util';

export default {
	json(val) {
		return JSON.stringify(val);
	},
	num(val) {
		if (!parseFloat(val)) return '-';
		return util.numFormat(val);
	},
	log(val) {
		console.log(val);
	},
	lower(val) {
		return String(val).toLowerCase();
	}
};
